import {
  parseSearchArrayValue,
  parseSearchNumberValue,
  parseSearchStringValue,
  parseSearchBooleanValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { ICcmOnboardingStatusReportFilters } from 'infrastructure/interfaces';

const defaultFilter: ICcmOnboardingStatusReportFilters = {
  clinicGuid: [],
  ccmStatuses: [],
  childClinic: true,
  page: 1,
};

const parseFunctions: TParseFunctions<ICcmOnboardingStatusReportFilters> = {
  page: parseSearchNumberValue,
  doctorGuid: parseSearchStringValue,
  patientGuid: parseSearchStringValue,
  clinicGuid: parseSearchArrayValue,
  ccmStatuses: parseSearchArrayValue,
  pcmStatus: parseSearchBooleanValue,
  childClinic: parseSearchBooleanValue,
};

export const useOnboardingStatusQueryFilter = () => {
  return useQueryFilterNew<ICcmOnboardingStatusReportFilters>(
    defaultFilter,
    parseFunctions,
    ['page'],
  );
};
